import Layout from '@/layout'

const groupRouter = {
  path: '/group',
  component: Layout,
  redirect: '/group/new_group_master',
  name: 'group',
  meta: {
    title: 'Đoàn',
    icon: ''
  },
  children: [
    {
      path: '/group/new_group_master',
      name: '',
      meta: {
        title: 'Tạo đoàn mới',
        icon: ''
      },
      component: () => import('@/views/mci/group/BookingGroupPage.vue')
    },
    {
      path: '/group/group_master_functions',
      name: '',
      meta: {
        title: 'Đoàn master',
        icon: ''
      },
      redirect: '/group/group_master_functions',
      component: () => import('@/views/nested/menu1/index'), // Parent router-view
      children: [
        // {
        //   path: '/group/search_group_master',
        //   redirect: '/group/group_master_functions',
        //   component: () => import('@/views/mci/group/searchGroupMaster.vue')
        // },
        {
          path: '/group/group_master_functions',
          name: '',
          meta: {
            activeMenu: '/group/group_master_functions'
          },
          component: () => import('@/views/mci/group/groupMasterFunctions.vue')
        }
      ]
    },
    {
      path: '/group/group_transactions',
      name: '',
      meta: {
        title: 'Giao dịch đoàn',
        icon: ''
      },
      component: () => import('@/views/mci/group/groupTransactions.vue')
    },
    // {
    //   path: '/group/group_log',
    //   name: '',
    //   meta: {
    //     title: 'Nhật ký đoàn',
    //     icon: ''
    //   },
    //   component: () => import('@/views/mci/group/groupLog.vue')
    // },
    {
      path: '/group/group_release_trace',
      name: '',
      meta: {
        title: 'Đoàn cần theo dõi',
        icon: ''
      },
      component: () => import('@/views/mci/group/groupReleaseTrace.vue')
    }
  ]
}

export default groupRouter
